define ['./phone.css'], () ->
  (RentappService, $state, $filter) ->
    restrict: "E"
    template: require("./phone.jade")
    scope: {field: "=", mode: "@", index: "=", stage: "="}
    link: (scope, element, attrs) ->
      if scope.field.required and scope.mode == 'edit'
        scope.field_label = "#{scope.field.label}<span>&nbsp;*</span>"
      else
        scope.field_label = scope.field.label



// WEBPACK FOOTER //
// ./directives/freeforms/phone/phone.coffee